import React from 'react';
import './../assets/css/components/_error.css';

export default function Error(props) {
  return (
    <div className="error">{props.text}</div>
  );
}